module.exports = __webpack_public_path__ + "static/media/sap.41d0702c.svg";